<template>
  <div class="relative flex flex-col min-w-0 break-words w-full h-full mb-4 shadow-lg rounded-lg bg-white">
    <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
      <div class="flex flex-wrap items-center">
        <div class="relative w-full max-w-full flex-grow flex-1">
          <h6 class="uppercase text-blueGray-400 mb-1 text-xs font-semibold">
            Details of activity hours
          </h6>
          <h2 class="text-blueGray text-xl font-semibold">
            Overview PLO of Course
          </h2>
        </div>
      </div>
    </div>
    <div class="p-4 flex-auto ">
      <div class="flex flex-wrap">
        <!--- Doctor of Medicine Program -->
        <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full  mb-4 shadow-md rounded-lg border-0"
          style="background-color: #ffdbcf;">
          <div class="flex flex-wrap items-center pb-4">
            <span class="text-black text-lg font-semibold text-blueGray">
              Doctor of Medicine Program
            </span>
            <div class="relative w-full max-w-full flex-grow flex-1 text-right">
              <button @click="toggleAccordion(26)" class="accordion-header cursor-pointer text-sm
               text-white px-3 py-1 rounded outline-none focus:outline-none mr-1 
               mb-1 ease-linear transition-all duration-150"  style="background-color: #D95742;" type="button">
                Show All</button>
            </div>
          </div>

          <div class="block overflow-x-auto w-full max-h-300-px shadow rounded-lg" v-if="showAccordion[26]">
            <table class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white">
              <thead class="sticky top-0">
                <tr>
                  <th
                    class="lg:w-100-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    No.
                  </th>
                  <th
                    class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    List of PLO
                  </th>
                  <th
                    class="lg:w-250-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    Hours
                  </th>                 
                </tr>
              </thead>
              <tbody>
                <tr v-if="co_act_med_arr.length === 0">
                  <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                </tr>
                <tr v-for="(co_act_med, index) in co_act_med_arr" :key="index">
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                   {{ co_act_med.number }}
                  </td>
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-left">
                    {{ co_act_med.plo }}
                  </td>
                  <td class="border-t-0 px-6 p-2 align-top border-l-0 border-r-0 text-center">
                    {{ co_act_med.sum_hours }}
                  </td>                
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--- Bachelor of Science (Radiological Technology) -->
        <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full mb-4 shadow-md rounded-lg border-0"
          style="background-color: #ffdbcf;">
          <div class="flex flex-wrap items-center pb-4">
            <span class="text-black text-lg font-semibold text-blueGray">
              Bachelor of Science (Radiological Technology)
            </span>
            <div class="relative w-full max-w-full flex-grow flex-1 text-right">
              <button @click="toggleAccordion(28)" class="accordion-header cursor-pointer text-sm 
               text-white px-3 py-1 rounded outline-none focus:outline-none mr-1 
               mb-1 ease-linear transition-all duration-150" style="background-color: #D95742;" type="button">
                Show All</button>
            </div>
          </div>

          <div class="block w-full overflow-x-auto max-h-300-px shadow rounded-lg" v-if="showAccordion[28]">
            <table class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white">
              <thead class="sticky top-0">
                <tr>
                  <th
                    class="lg:w-100-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    No.
                  </th>
                  <th
                    class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    List of PLO
                  </th>
                  <th
                    class="lg:w-250-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    Hours
                  </th>             
                </tr>
              </thead>
              <tbody>
                <tr v-if="co_act_sci_radio_arr.length === 0">
                  <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                </tr>
                <tr v-for="(co_act_sci_radio, index) in co_act_sci_radio_arr" :key="index">
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                   {{ co_act_sci_radio.number }}
                  </td>
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-left">
                    {{ co_act_sci_radio.plo }}
                  </td>
                  <td class="border-t-0 px-6 p-2 align-top border-l-0 border-r-0 text-center">
                    {{ co_act_sci_radio.sum_hours }}
                  </td>                
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--- Bachelor of Science (Physical Therapy) -->
        <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full mb-4 shadow-md rounded-lg border-0"
          style="background-color: #ffdbcf;">
          <div class="flex flex-wrap items-center pb-4">
            <span class="text-black text-lg font-semibold text-blueGray">
              Bachelor of Science (Physical Therapy)
            </span>
            <div class="relative w-full max-w-full flex-grow flex-1 text-right">
              <button @click="toggleAccordion(29)" class="accordion-header cursor-pointer text-sm 
               text-white px-3 py-1 rounded outline-none focus:outline-none mr-1 
               mb-1 ease-linear transition-all duration-150" style="background-color: #D95742;" type="button">
                Show All</button>
            </div>
          </div>

          <div class="block w-full overflow-x-auto max-h-300-px shadow rounded-lg" v-if="showAccordion[29]">
            <table class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white">
              <thead class="sticky top-0">
                <tr>
                  <th
                    class="lg:w-100-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    No.
                  </th>
                  <th
                    class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    List of PLO
                  </th>
                  <th
                    class="lg:w-250-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    Hours
                  </th>        
                </tr>
              </thead>
              <tbody>
                <tr v-if="co_act_sci_therapy_arr.length === 0">
                  <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                </tr>
                <tr v-for="(co_act_sci_therapy, index) in co_act_sci_therapy_arr" :key="index">
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                   {{ co_act_sci_therapy.number }}
                  </td>
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-left">
                    {{ co_act_sci_therapy.plo }}
                  </td>
                  <td class="border-t-0 px-6 p-2 align-top border-l-0 border-r-0 text-center">
                    {{ co_act_sci_therapy.sum_hours }}
                  </td>                
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!--- Bachelor of Science (Emergency Medical Operation) -->
        <div class="w-full lg:w-12/12 mr-auto px-4 pt-6 pb-2 h-full shadow-md rounded-lg border-0"
          style="background-color: #ffdbcf;">
          <div class="flex flex-wrap items-center pb-4">
            <span class="text-black text-lg font-semibold text-blueGray">
              Bachelor of Science (Emergency Medical Operation)
            </span>
            <div class="relative w-full max-w-full flex-grow flex-1 text-right">
              <button @click="toggleAccordion(30)" class="accordion-header cursor-pointer text-sm 
               text-white px-3 py-1 rounded outline-none focus:outline-none mr-1 
               mb-1 ease-linear transition-all duration-150" style="background-color: #D95742;" type="button">
                Show All</button>
            </div>
          </div>

          <div class="block w-full overflow-x-auto max-h-300-px shadow rounded-lg" v-if="showAccordion[30]">
            <table class="lg:table-fixed md:table-auto sm:table-auto w-full border-collapse items-center rounded-lg bg-white">
              <thead class="sticky top-0">
                <tr>
                  <th
                    class="lg:w-100-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    No.
                  </th>
                  <th
                    class="px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    List of PLO
                  </th>
                  <th
                    class="lg:w-250-px px-4 align-top border border-solid py-2 border-l-0 border-r-0 font-semibold text-black" style="background-color: #FCA081;">
                    Hours
                  </th>         
                </tr>
              </thead>
              <tbody>
                <tr v-if="co_act_sci_er_arr.length === 0">
                  <td colspan="3" class="text-center py-4 text-red-500 font-semibold text-base">No Data Found</td>
                </tr>
                <tr v-for="(co_act_sci_er, index) in co_act_sci_er_arr" :key="index">
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-center">
                   {{ co_act_sci_er.number }}
                  </td>
                  <td class="border-t-0 p-2 align-top border-l-0 border-r-0 text-left">
                    {{ co_act_sci_er.plo }}
                  </td>
                  <td class="border-t-0 px-6 p-2 align-top border-l-0 border-r-0 text-center">
                    {{ co_act_sci_er.sum_hours }}
                  </td>                
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import api from './../../services/student_services';

export default {
  name: "card-stats",
  data() {
    return {
      openTab: 1,
      co_act_med_arr: [],
      co_act_sci_radio_arr: [],
      co_act_sci_therapy_arr: [],
      co_act_sci_er_arr: [],
      showAccordion: {
        26: true,
        28: false,
        29: false,
        30: false
      },
    }
  },
  methods: {
    toggleAccordion(accordionNumber) {
      // กำหนดค่าให้กับคุณสมบัติที่เปิดหรือปิดของแต่ละ Accordion
      this.showAccordion[accordionNumber] = !this.showAccordion[accordionNumber];
    },
    async edu_year() {
      api.edu_year().then(async (result) => {
        this.edu_year_arr = result.data;
      });
    },
    async co_act_med() {
      api.co_act_med().then(async (result) => {
        this.co_act_med_arr = result.data;
      });
    },
    async co_act_sci_radio() {
      api.co_act_sci_radio().then(async (result) => {
        this.co_act_sci_radio_arr = result.data;
      });
    },
    async co_act_sci_therapy() {
      api.co_act_sci_therapy().then(async (result) => {
        this.co_act_sci_therapy_arr = result.data;
      });
    },
    async co_act_sci_er() {
      api.co_act_sci_er().then(async (result) => {
        this.co_act_sci_er_arr = result.data;
      });
    },
  }, created: async function () {
    await this.edu_year(),
    await this.co_act_med(),
    await this.co_act_sci_radio(),
    await this.co_act_sci_therapy(),
    await this.co_act_sci_er()
  },
}
</script>